const faqs = [
    { 
        id: 1, 
        heading: 'How do I schedule a test drive?',
        content: 'Scheduling a test drive is easy! You can either call our dealership or use our online scheduling tool. Just select your preferred date and time, and we’ll confirm your appointment.',
    }, 
    { 
        id: 2,
        heading: 'What financing options are available?',
        content: 'We offer a range of financing options to suit your needs, including low-interest loans, lease deals, and special financing for qualified buyers. Speak to our finance team for personalized advice.',
    },
    {
        id: 3, 
        heading: 'How does the trade-in process work?',
        content: 'Trading in your old vehicle is simple. Bring your car to our dealership for an appraisal, and we’ll offer you a fair market value. This amount can be applied towards the purchase of your new car.',
    },
    {
        id: 4,
        heading: 'What is covered under the warranty?',
        content: 'Our vehicles come with a comprehensive warranty that covers various components and systems. Contact our service department to get detailed information about specific warranty coverage.',
    },
    {
        id: 5,
        heading: 'How do I book a service appointment?',
        content: 'Booking a service appointment is convenient with our online booking system. Select the service you need, choose a suitable time, and we’ll confirm your appointment.',
    },
];

export default faqs;